module.exports = __webpack_public_path__ + "img/5_117.05b1d751.png";